import { Controller, useFormContext, useFormState } from 'react-hook-form';
import { getErrorByPath } from '../formComponents.utils';
import BaseSelect from './BaseSelect';

/**
 * @component ControlledSelect
 *
 * React Hook Form controlled wrapper for BaseSelect.
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.id
 * @param {Object} [props.rules]
 * @param {boolean} [props.showErrorInline=true]
 * @param {boolean} [props.reserveErrorSpace=false]
 * @returns {React.ReactElement}
 */
export default function ControlledSelect(props: any) {
  const { name, rules, showErrorInline = true, reserveErrorSpace = false, ...rest } = props;

  const { control } = useFormContext();

  const { errors } = useFormState({ name });
  const error = getErrorByPath(errors, name);

  const errorMessage = showErrorInline ? error?.message : undefined;
  const hasError = showErrorInline ? Boolean(error) : false;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={rest.multiple ? [] : ''}
      render={({ field }) => (
        <BaseSelect
          {...rest}
          value={field.value}
          onChange={field.onChange}
          error={hasError}
          errorMessage={errorMessage}
          showErrorInline={showErrorInline}
          reserveErrorSpace={reserveErrorSpace}
        />
      )}
    />
  );
}
